import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import { FeatureSource, ModelBase, PlayerObject } from "@models";
import { 
  FightingStyle, 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function FightingStyleEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [obj, setObj] = useState<FightingStyle>(api.applyWorkingOn(new FightingStyle()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof FightingStyle) {
          setObj(res[0].clone());
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "fighting_style", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("fighting_style", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/fighting_style");
  //     });
  //   }
  // }

  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="fighting_style"
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: FeatureSource) => {
          if (changed instanceof FightingStyle) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
          }
        }}
      >
      </FeatureSourceInput>
    ); 
  }
}
